import { useAppSelector } from "../../../utils/hooks/store";
import { SearchParameters } from "../../../reducers/componentSearch";
import { AppliedFilter, AppliedFiltersList } from "./FilterStyles";
import Icon from "../../common/Icon";
import { useUpdateSearch } from "../../../utils/hooks/partSearch";
import { useParameters } from "../../../utils/hooks/commonly-stored/parameters";
import { formatSIWithUnit } from "../../../utils/properties";
import { useCategories } from "../../../utils/hooks/commonly-stored/categories";

export default function AppliedFilters() {
  const searchParameters = useAppSelector(
    (state) => state.componentSearch.searchParameters as SearchParameters,
  );
  const updateSearch = useUpdateSearch();
  const parameters = useParameters();
  const { categories } = useCategories();

  const filterValues = Object.values(searchParameters.filters);
  const noFiltersSelected =
    filterValues.length == 0 ||
    filterValues.every((values) => values === undefined || values.length == 0);
  const noCategoriesSelected = searchParameters.categoryIds.length == 0;

  if (
    (noFiltersSelected && noCategoriesSelected) ||
    parameters === null ||
    categories === null
  ) {
    return null;
  }

  const removeFilter = (parameterShortName: string, value: string) => {
    const newFilters = {
      ...searchParameters.filters,
      [parameterShortName]: searchParameters.filters[
        parameterShortName
      ]?.filter((existingValue) => existingValue !== value),
    };
    if (newFilters[parameterShortName]?.length == 0) {
      delete newFilters[parameterShortName];
    }
    updateSearch({ updateSearchParameters: { filters: newFilters } });
  };

  const removeCategory = (categoryIdToRemove: string) => {
    updateSearch({
      updateSearchParameters: {
        categoryIds: searchParameters.categoryIds.filter(
          (categoryId) => categoryId !== categoryIdToRemove,
        ),
      },
    });
  };

  return (
    <AppliedFiltersList>
      {searchParameters.categoryIds.map((categoryId) => {
        return (
          <AppliedFilter key={categoryId}>
            {
              categories.find((category) => category.octopart_id == categoryId)
                ?.name
            }
            <Icon
              src="/icons/close.svg"
              alt="Remove filter"
              styleProps={{ margin: 0, cursor: "pointer" }}
              iconDimension={16}
              onClick={() => removeCategory(categoryId)}
            />
          </AppliedFilter>
        );
      })}
      {Object.entries(searchParameters.filters).map(
        ([parameterShortName, values]) => {
          if (values !== undefined) {
            return values.map((value) => {
              const parameter =
                parameters.parametersByShortName[parameterShortName];
              if (parameter !== undefined) {
                const displayValue =
                  parameter.unit === null
                    ? value
                    : formatSIWithUnit(parseFloat(value), parameter.unit);
                return (
                  <AppliedFilter key={`${parameterShortName}-${value}`}>
                    {displayValue}
                    <Icon
                      src="/icons/close.svg"
                      alt="Remove filter"
                      styleProps={{ margin: 0, cursor: "pointer" }}
                      iconDimension={16}
                      onClick={() => removeFilter(parameterShortName, value)}
                    />
                  </AppliedFilter>
                );
              }
            });
          }
        },
      )}
    </AppliedFiltersList>
  );
}
